import { render, staticRenderFns } from "./ExerciseSeriesEditor.vue?vue&type=template&id=5a3bce70&scoped=true"
import script from "./ExerciseSeriesEditor.vue?vue&type=script&lang=js"
export * from "./ExerciseSeriesEditor.vue?vue&type=script&lang=js"
import style0 from "./ExerciseSeriesEditor.vue?vue&type=style&index=0&id=5a3bce70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3bce70",
  null
  
)

export default component.exports